import React from "react";
import { Marker, InfoWindow } from "@react-google-maps/api";
import { InfoContainer, InfoHeader, InfoSeparator, InfoRow } from "./styles";

const MapMarker = (props) => {
  const {
    item,
    isOpen,
    idMarker,
    icon,
    color,
    config,
    clock = "",
    lat,
    lng,
  } = props;
  const { onSelect, onCloseInfo } = props;

  const fieldRow = (row, clock) => {
    if (row.isFunction) {
      const params = row.params.map((param) => item[param]);

      let propsParams = [];

      if (row.hasClock) {
        propsParams.push(clock);
      } else {
        propsParams = row.propsParams
          ? row.propsParams.map((param) => item[param])
          : [];
      }

      if (row.hasFormat) {
        params.push(row.formatParams);
        propsParams.push(row.formatPropsParams);
      }
      return row.fn(...params, ...propsParams);
    }

    if (row.field) {
      return row.isLength ? item[row.field].length : item[row.field];
    }
    return "";
  };

  return (
    <Marker
      onClick={() => onSelect(item[idMarker])}
      position={{ lat, lng }}
      icon={{
        url: icon,
      }}
    >
      {isOpen && (
        <InfoWindow
          position={{ lat, lng }}
          clickable={true}
          onCloseClick={() => onCloseInfo(item[idMarker])}
        >
          <InfoContainer>
            <InfoHeader>
              {config.title}
              {config.field ? item[config.field] : ""}
              {` ${clock}`}
            </InfoHeader>
            <InfoSeparator color={color} />
            {config.rows.length > 0 &&
              config.rows.map((row, index) => {
                return (
                  <InfoRow key={`${row.text}-${index}`}>
                    <strong>{row.text}</strong>
                    {row.beforeText ? `${row.beforeText}` : ""}
                    {row.isClock ? clock : ""}
                    {fieldRow(row, clock)}
                    {row.afterText ? ` ${row.afterText}` : ""}
                  </InfoRow>
                );
              })}
          </InfoContainer>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default React.memo(MapMarker);
